/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
} from "@material-tailwind/react";
import { Link } from 'react-router-dom';



import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import React, { useEffect } from "react"
import Glide from "@glidejs/glide"
import Navbarsection from "../views/Home/Navbarsection";
import Footersection from "../views/Home/Footersection";
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 2000, min: 1000 },
    items: 4
  },
  desktop: {
    breakpoint: { max: 2000, min: 900 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items:1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};
// eslint-disable-next-line react-refresh/only-export-components
function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="h-3 w-3"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 12.75l6 6 9-13.5"
      />
    </svg>
  );
}
export default function Newupdates() {
  return (
   <>
   <section className="mt-[11px]">
   <div class="mx-auto">
      <div  class="mt-[6px] text-gray-600 body-font  ">
      <h3 class="text-center lg:text-[22px] font-bold sm:text-2xl"> New Latest Updates   <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Plugins" class=" " 
>  <Button className="ml-2 bg-orange-600">   View All  <i style={{fontSize:12}} class="fas fa-chevron-right"></i></Button> </Link> </h3>
        </div>
      </div>
  
      <Carousel responsive={responsive}  className="z-[0] overscroll-x-none P-4 mt-[22px]" >
    {/* End Portfolio 0   */}


    <div className="p-1">
   <Card className="mb-0px]  p-[8px] mt-0 w-90">
         <CardHeader color="blue-gray" className="rounded relative h-56">
           <img src="./assets/new/luxetta.png"
             alt="Bhumiratnaagriscience" />
         </CardHeader>
   
         <CardBody className="mb-[-22px] ">
           <Typography style={{fontSize:17}} variant="h5" color="blue-gray" className="mb-0">
           Luxetta Hotel <br></br> Templates Sitekit ( Wordpress ) 
           </Typography>
           <Typography>

           luxetta Resort & Hotel | Sitekit with all function like booking etc.  
            </Typography>
         </CardBody>
    
         <CardFooter className="mt-[-16px]">
          <a href="https://www.bhumiratnaagriscience.com/" target="_blank"> <Button className="bg-orange-600"> <i style={{fontSize:12}} class="px-1 py-1 p-1 fa-solid fa-up-right-from-square "></i>
           Preview Demo  </Button></a> 
          <a href="https://play.google.com/store/apps/details?id=com.bhumiratnaagriscience.com&hl=en_US" target="_blank"> <Button className="bg-black ">  Buy Now <i style={{fontSize:12}} class="fas fa-chevron-right"></i></Button></a>
         </CardFooter>
       </Card>
  
   </div>
  {/* End Portfolio 0   */}


 {/* Start  Portfolio 1  */}
 
 <div className="p-1">
   <Card className="mb-7px]  p-[4px] mt-0 w-90">
         <CardHeader color="blue-gray" className="rounded relative h-56">
           <img src="./assets/new/luxetta.png"
             alt="Bhumiratnaagriscience" />
         </CardHeader>
   
         <CardBody className="mb-[-22px] ">
           <Typography style={{fontSize:17}} variant="h5" color="blue-gray" className="mb-0">
           Luxetta Hotel <br></br> Templates Sitekit ( Wordpress ) 
           </Typography>
           <Typography>

           luxetta Resort & Hotel | Sitekit with all function like booking etc. 

            </Typography>
         </CardBody>
    
         <CardFooter className="mt-[-16px]">
          <a href="https://www.bhumiratnaagriscience.com/" target="_blank"> <Button className="bg-orange-600"> <i style={{fontSize:12}} class="px-1 py-1 p-1 fa-solid fa-up-right-from-square "></i>
           Preview Demo  </Button></a> 
          <a href="https://play.google.com/store/apps/details?id=com.bhumiratnaagriscience.com&hl=en_US" target="_blank"> <Button className="bg-black ">  Buy Now <i style={{fontSize:12}} class="fas fa-chevron-right"></i></Button></a>
         </CardFooter>
       </Card>
  
   </div>
  
 {/* Start Portfolio 2 */}
 
 {/* Start  Portfolio 3 */}


   


</Carousel>

  </section>

    
   </>
  )
}
 